// extracted by mini-css-extract-plugin
module.exports = {"app_tray":"AppIcons--app_tray--AF3Ql","app_icon":"AppIcons--app_icon--3-XkC"};